const getFullNamesFromArray = (personsArray) => {
  if (!Array.isArray(personsArray)) return "";
  return personsArray
    .filter((person) => person && typeof person === "object" && person.fullName)
    .map((person) => person.fullName.trim())
    .join(", ");
};

export default getFullNamesFromArray;
